import React from "react";
import ChangePasswordContainer from "../../../containers/Auth/ChangePassword";

const ChangePasswordScreen = ({ listConfig }) => {
  return <ChangePasswordContainer listConfig={listConfig} />;
};
export default ChangePasswordScreen;
